import { AppAction } from '@om-fe/store';
export const TOP_BETS_PATH: string = 'next-sports-by-popularity-with-live';
export const TOP_BETS_SPORT_WITH_LOCATION_PATH: string = 'next-locations-by-popularity-with-live/:disciplineId';
export const TOP_BETS_SPORT_WITH_CATEGORY_PATH: string = 'next-categories-by-popularity-with-live/:disciplineId';
export const TOP_BETS_SPORT_WITH_CHILDREN_PATH: string = 'next-sport-children-by-popularity-with-live/:disciplineId';
export const TOP_BETS_TIMERANGE_PATH: string = 'time-ranges-discipline/:disciplineId';
export const TOP_BETS_TIMERANGE_WITH_LOCATION_PATH: string = 'time-ranges-discipline-location/:disciplineId/:locationId';
export const TOP_BETS_TIMERANGE_WITH_CATEGORY_PATH: string = 'time-ranges-discipline-category/:disciplineId/:categoryId';
export const TOP_BETS_MATCH_LIST_PATH: string = 'next-matches-aggregator-groups-overview-top-bets/:disciplineId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_MATCH_LIST_ALL_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted/:disciplineId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_MATCH_LIST_LOCATION_PATH: string = 'next-matches-aggregator-groups-overview-top-bets/:disciplineId/:locationId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_MATCH_LIST_LOCATION_ALL_PATH: string = 'next-matches-aggregator-groups-overview-lm-sorted/:disciplineId/:locationId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_MATCH_LIST_CATEGORY_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-top-bets/:disciplineId/:categoryId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_MATCH_LIST_CATEGORY_ALL_PATH: string = 'next-matches-aggregator-groups-overview-by-event-category-lm-sorted/:disciplineId/:categoryId/:timerange/:limit/:groupOverviewId';
export const TOP_BETS_TIME_RANGE_PATH: string = 'time-ranges-discipline/:disciplineId/:offsetTime';
export const TOP_BETS_TIME_RANGE_LOCATION_PATH= 'time-ranges-discipline-location/:disciplineId/:offsetTime/:locationId';
export const TOP_BETS_TIME_RANGE_CATEGORY_PATH= 'time-ranges-discipline-category/:disciplineId/:offsetTime/:categoryId';

export enum TopBetsTab {
    TopBets = 'topBets',
    All = 'all',
    ElectronicSports = 'electronicSports',
}

export enum TopBetsTimeRangeActions {
    SetLoadingData = 'sports:top-bets-time-range:set-loading-data',
    SetFilterData = 'sports:top-bets:set-top-bets-time-range-filter-data',
}

export const slicePrefix = `Top-Bets`;

export enum TimeRangeType {
    LIVE = 'LIVE',
    HOURS = 'HOURS',
    DAYS = 'DAYS',
    LATER ='LATER',
}

export interface TopBetsLocationCategoryTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
    };
}

export interface TopBetsTimeRangeTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly offsetTime: number;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}

export interface TopBetsMatchListTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
        readonly timerange: string;
        readonly groupOverviewIds: string;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}

export interface TopBetsTimeRangeSetLoadingData extends AppAction<TopBetsTimeRangeActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingData: boolean;
    };
}

export interface TopBetsTimeRangeSetFilterDataAction extends AppAction<TopBetsTimeRangeActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly disciplineId: string;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}

export interface TopBetsTimeRangeTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId?: string;
        readonly offsetTime: number;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}


export interface TopBetsTimeRangeStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly locationId?: string;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly eventCategoryId?: string;
    readonly marketGroupsOverviewNumber?: number;
    readonly marketGroupsOverviewIds?: string;
}

export enum TimeRangeDisplay {
    Live = 'Live',
    Today = 'Today',
    Later = 'Later',
}
